import { UpdateGiftCardProviderPayload } from 'api/giftCardProviders'
import { GiftCardsState } from 'slices/giftCards/types'

type FileUploadPayload = { file_upload_id: number } | { destroy: boolean }

function buildImageUpload(imageState?: {
  fileUploadId?: number
  destroy?: boolean
}): FileUploadPayload | null {
  if (imageState?.fileUploadId) {
    return { file_upload_id: imageState.fileUploadId }
  }

  if (imageState?.destroy) {
    return { destroy: true }
  }

  return null
}

export function getFileUploadsPayload(
  giftCardProviderState: GiftCardsState['providers'][number]
) {
  const fileUploads: UpdateGiftCardProviderPayload['gift_card_provider']['file_uploads'] =
    {}

  const cardImage = buildImageUpload(giftCardProviderState.cardImage)
  if (cardImage) {
    fileUploads.card_background_image = cardImage
  }

  const linkImage = buildImageUpload(giftCardProviderState.linkImage)
  if (linkImage) {
    fileUploads.external_link_image = linkImage
  }

  return fileUploads
}

export function validateGiftCardProvider(
  providerConfig: GiftCardsState['providers'][number]
): string | null {
  // Validate custom image is uploaded when card_image_type is 'custom'
  if (
    providerConfig.cardImageType === 'custom' &&
    !providerConfig.cardImage?.fileUploadId &&
    !providerConfig.cardImage?.id
  ) {
    return 'alert_custom_image_missing'
  }

  // Validate external link image is uploaded when external_link_enabled is true
  if (
    providerConfig.externalLinkEnabled &&
    !providerConfig.linkImage?.fileUploadId &&
    !providerConfig.linkImage?.id
  ) {
    return 'alert_external_link_image_missing'
  }

  return null
}
